import {Pipe, PipeTransform} from '@angular/core';
import {Farmer} from "../models/farmer";

@Pipe({
  name: 'farmerPipe'
})
export class FarmerPipe implements PipeTransform {
  transform(farmer: Farmer): string {
    if(!farmer){
      return '';
    }
    return  farmer.lastName + " " + farmer.firstName + "<br/><small>" + farmer.cin + "</small> " ;
  }
}
